import React from "react"

const buttonStyle = {
  border: "none",
  color: "inherit",
  fontFamily: "Helvetica, sans-serif",
  fontWeight: "bold",
  fontSize: "3rem",
  marginTop: "50px",
};


const divStyle = {
  width: "100vw",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};

export default () => (
  <div style={divStyle}>
    <iframe
      src="https://giphy.com/embed/LEKnC9xxE5CyQ"
      title="gif"
      width="480"
      height="271"
      frameBorder="0"
      class="giphy-embed"
      allowFullScreen
    ></iframe>
    <a style={buttonStyle} href="/admin">
      Go to CMS -->
    </a>
  </div>
);
